import React, { useState, useEffect, useRef } from "react";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import OTPVerification from "./OTPVerification";
import { OverlayPanel } from "primereact/overlaypanel";
import { useDispatch } from "react-redux";
import pswdicon from "../../Assets/pswdicon.png";
import { verifySetRestPswd } from "../../Store/newUser/NewUserAction";
import "./LoginStyle.scss";

const ResetPassword = ({ newUser }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [contact, setContact] = useState("");
  const [fieldsAreFilled, setFieldsAreFilled] = useState(false);
  const [fieldsRequiredError, setFieldsRequiredError] = useState(false);
  const [passwordRequiredError, setPasswordRequiredError] = useState(false);
  const [, setConfirmPasswordRequiredError] = useState(false);
  const [pswdRegexErr, setPasswdRegexErr] = useState(false);
  const [passwordNotMatchErr, setPasswordNotMatchErr] = useState(false);
  const navigate = useNavigate();
  const [overlayVisible, setOverlayVisible] = useState(false);
  const regexpasswd =
    /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"|,.<>/?]).{8,}$/;
  const op = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const contactFromState = location.state?.contact;
    if (contactFromState) {
      setContact(contactFromState);
    }
  }, [location.state]);

  const verifyPassword = () => {
    console.log("Verifying Password...");
  };
  useEffect(() => {
    if (otp && contact) {
      // Trigger the password verification process
      verifyPassword();
    }
  }, [otp, contact]);

  const handleEnteredNumbers = (enteredNumbers) => {
    setOtp(enteredNumbers);
    console.log("Entered numbers from resetPassword:", enteredNumbers);
  };
  const resetErrors = () => {
    setPasswdRegexErr(false);
    setPasswordNotMatchErr(false);
    setPasswordRequiredError(false);
    setFieldsRequiredError(false);
    setConfirmPasswordRequiredError(false);
  };
  const passwordButtonHandler = () => {
    switch (true) {
      case password.trim() === "" && confirmPassword.trim() === "":
        setPasswordRequiredError(true);
        setConfirmPasswordRequiredError(true);
        setPasswordNotMatchErr(false);
        break;
      case password !== confirmPassword:
        setPasswordNotMatchErr(true);
        break;
      case !regexpasswd.test(password):
        setPasswdRegexErr(true);
        break;
      case !fieldsAreFilled:
        setFieldsRequiredError(true);
        break;
      default:
        resetErrors();
        dispatch(verifySetRestPswd(newUser, otp, password, contact, navigate));
    }
  };
  const passwordRequiredHandler = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const isPasswordEmpty = newPassword === "";
    const isPasswordValid = regexpasswd.test(newPassword);
    const doPasswordsMatch = newPassword === confirmPassword && confirmPassword !== "";
    setPasswordRequiredError(isPasswordEmpty);
    setPasswdRegexErr(!isPasswordValid);
    setPasswordNotMatchErr(doPasswordsMatch);
  };

  const confirmPasswordRequiredHandler = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    const isConfirmPasswordEmpty = newConfirmPassword === "";
    const passwordsNotMatch = password !== newConfirmPassword && password !== "";
    setConfirmPasswordRequiredError(isConfirmPasswordEmpty);
    setPasswordNotMatchErr(passwordsNotMatch);
  };
  return (
    <div data-testid="reset-password-container">
      <div className="mb-2">
        <OTPVerification
          newUser={newUser}
          handleEnteredNumbers={handleEnteredNumbers}
          contact={contact}
          fieldsAreFilled={fieldsAreFilled}
          setFieldsAreFilled={setFieldsAreFilled}
          fieldsRequiredError={fieldsRequiredError}
          setFieldsRequiredError={setFieldsRequiredError}
          data-testid="otp-verification"
        />
      </div>
      <div>
        <div className="text-blue-900 font-semibold text-4xl ">
          {newUser ? "Set Password" : "Reset Password"}
        </div>
        <div className="text-500 text-sm w-30rem ">Setup your New Password</div>
        <div className="flex">
          <p className="mr-1 mb-3 pinkcolor"> * </p>
          <p className="text-blue-900 font-semibold">New Password</p>
          <img
            src={pswdicon}
            alt="pswdicon"
            style={{
              height: "1rem",
              width: "1rem",
              marginTop: "1.2rem",
              marginLeft: "0.5rem",
            }}
            onMouseEnter={(e) => {
              op.current.toggle(e);
              console.log("Mouse entered");
            }}
            onMouseLeave={(e) => {
              op.current.toggle(e);
              console.log("Mouse left");
            }}
          />
        </div>
        <div className="">
          <Password
            className="custom-password w-30rem mr-3"
            value={password}
            onChange={(e) => passwordRequiredHandler(e)}
            feedback={false}
            toggleMask
            data-testid="new-password-input"
          />
          {passwordRequiredError ? (
            <p className="text-red-500">Password is required</p>
          ) : (
            ""
          )}
          {pswdRegexErr ? (
            <div className="text-red-500">
              Pattern mismatch! Please input according to the specified format
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="flex">
          <p className="mr-1 mb-3 pinkcolor"> * </p>
          <p className="text-blue-900 font-semibold"> Confirm Password</p>
        </div>
        <div className="">
          <Password
            className="custom-password w-30rem mr-3"
            value={confirmPassword}
            onChange={(e) => confirmPasswordRequiredHandler(e)}
            feedback={false}
            toggleMask
            data-testid="confirm-password-input"
          />
          {passwordNotMatchErr ? (
            <div className="text-red-500">
              Password and Confirm Password does not Match
            </div>
          ) : (
            ""
          )}
          <Button
            className="login-btn mt-4 w-30rem"
            onClick={passwordButtonHandler}
            data-testid="password-button"
          >
            {newUser ? "Set Password" : "Reset Password"}
          </Button>
        </div>
        <OverlayPanel
          ref={op}
          appendTo={document.body}
          showCloseIcon={false}
          onHide={() => setOverlayVisible(false)}
          visible={overlayVisible}
          at="top"
          trigger="hover"
          className="borderStyle"
        >
          <div className="overlay-content p-2">
            <div>Password should contain at least 8 characters.</div>
            <div>Password should contain at least 1 lowercase letter.</div>
            <div>Password should contain at least 1 uppercase letter.</div>
            <div>Password should contain at least 1 special character.</div>
            <div>Password should contain at least 1 number.</div>
          </div>
        </OverlayPanel>
      </div>
    </div>
  );
};

export default ResetPassword;
